import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, delay, fromEvent, merge, Subscription, take } from 'rxjs';

import { BUILD_CONFIG } from '../static/build-config.token';
import debounce from '../utils/rxjs/decorators/debounce.decorator';
import { fromWindowEvent } from 'core/utils/rxjs/window-event';

@Injectable({
  providedIn: 'root',
})
export class InputTypeService {
  isTouch$ = new BehaviorSubject<boolean>(false);

  private _interactionSubscription: Subscription | null = null;
  private _justTouched?: boolean;

  constructor(@Inject(BUILD_CONFIG) private build: BaseBuildConfig) {}

  onUserInteraction(cb: () => void) {
    if (this._interactionSubscription || this.build.ssr) {
      return;
    }
    const click$ = fromEvent(document, 'click');
    const scroll$ = fromEvent(document, 'scroll');
    this._interactionSubscription = merge(click$, scroll$)
      .pipe(take(1), delay(1500))
      .subscribe(() => {
        cb();
        this._interactionSubscription?.unsubscribe();
      });
  }

  initialize() {
    if (this.build.ssr) {
      return;
    }
    fromWindowEvent('touchstart').subscribe(() => this.onTouchStart());
    fromWindowEvent('mousedown').subscribe(() => this.onMouseEvent());
    fromWindowEvent('mousemove').subscribe(() => this.onMouseEvent());
    fromWindowEvent('touchend').subscribe(() => this.onTouchEnd());
  }

  private onTouchStart() {
    this._justTouched = true;
    this.isTouch$.next(true);
  }

  private onMouseEvent() {
    if (!this._justTouched) {
      this.isTouch$.next(false);
    }
  }

  @debounce(350)
  private onTouchEnd() {
    this._justTouched = false;
  }
}
